import { ReactNode } from 'react';
import { cn } from 'utils/cn';

export interface MainCardProps {
    title?: ReactNode;
    /** Draws the 1px ring the card uses instead of a border. */
    border?: boolean;
    /** Wraps the children in the card's padded content box; `false` hands them the whole card. */
    content?: boolean;
    className?: string;
    /** Classes for the padded content box. */
    contentClassName?: string;
    children?: ReactNode;
}

export default function MainCard({
    title,
    border = true,
    content = true,
    className,
    contentClassName,
    children,
}: MainCardProps) {
    return (
        <div className={cn('bg-paper text-fg relative overflow-hidden rounded-lg', border && 'shadow-card', className)}>
            {title ? (
                <div className="border-divider flex items-center border-b p-5">
                    <span className="text-subtitle1 block">{title}</span>
                </div>
            ) : null}
            {content ? <div className={cn('p-5', contentClassName)}>{children}</div> : children}
        </div>
    );
}
